import React from 'react'
import { HeaderItem } from './HeaderItem'
import { HeaderStyle } from './styles'
import { SortingInterface } from '../../hooks/useSorting'

export interface Column {
  label: string
  key: string
  width?: string
  minWidth?: string
  sortable?: boolean
}

export interface HeaderProps {
  model: Column[]
  lineHeight?: string
  padding?: string
  alignItems?: string
  sorting?: SortingInterface<string>
}

export const Header = ({ model, lineHeight, padding, alignItems, sorting }: HeaderProps): JSX.Element => {
  const { length } = model

  return (
    <HeaderStyle lineHeight={lineHeight} padding={padding} alignItems={alignItems}>
      {model.map(({ key, ...others }) => (
        <HeaderItem key={key} columnKey={key} sorting={sorting} itemsCount={length} {...others} />
      ))}
    </HeaderStyle>
  )
}
